import { render, staticRenderFns } from "./ReleaseNotesDialog.vue?vue&type=template&id=000fbdcc&scoped=true"
import script from "./ReleaseNotesDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./ReleaseNotesDialog.vue?vue&type=script&setup=true&lang=js"
import style0 from "./ReleaseNotesDialog.vue?vue&type=style&index=0&id=000fbdcc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "000fbdcc",
  null
  
)

export default component.exports